import { __assign, __rest } from "tslib";
import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import './Checkbox.scss';
var Checkbox = function (_a) {
    var className = _a.className, errorMessage = _a.errorMessage, isChecked = _a.isChecked, isDisabled = _a.isDisabled, isIndeterminate = _a.isIndeterminate, isRequired = _a.isRequired, label = _a.label, onChange = _a.onChange, props = __rest(_a, ["className", "errorMessage", "isChecked", "isDisabled", "isIndeterminate", "isRequired", "label", "onChange"]);
    var containerClass = classnames('Checkbox', className, {
        'Checkbox--isChecked': isChecked,
        'Checkbox--isDisabled': isDisabled,
        'Checkbox--isIndeterminate': isIndeterminate,
        'Checkbox--isUnchecked': !isIndeterminate && !isDisabled && !isChecked
    });
    var checkIcon = (React.createElement("svg", { "aria-hidden": 'true', className: 'Checkbox__checkedIcon', role: 'presentation', viewBox: '0 0 32 32' },
        React.createElement("path", { d: 'M29.125 2.874L11.518 28.026a2.567 2.567 0 01-4.164.069l-4.479-5.971' })));
    var indeterminateIcon = (React.createElement("svg", { "aria-hidden": 'true', className: 'Checkbox__indeterminateIcon', role: 'presentation', viewBox: '0 0 32 32' },
        React.createElement("path", { d: 'M2.0938 16.0938h28' })));
    var getIcon = function () {
        if (isIndeterminate) {
            return indeterminateIcon;
        }
        else if (isChecked) {
            return checkIcon;
        }
        else {
            return null;
        }
    };
    return (React.createElement("label", __assign({}, props, { className: containerClass }),
        React.createElement("div", { className: 'u-inlineFlex u-flexAlign-c' },
            React.createElement("input", { "aria-checked": isChecked, checked: isChecked, className: 'Checkbox__nativeCheckmark', "data-testid": "checkbox ".concat(label), disabled: isDisabled, onChange: function () { return onChange(!isChecked); }, required: isRequired, type: 'checkbox' }),
            React.createElement("span", { className: 'Checkbox__checkboxAndLabel' },
                React.createElement("div", { className: 'Checkbox__svgCheckmark' }, getIcon()),
                label ? (React.createElement("span", { className: 'Checkbox__label' },
                    isRequired ? React.createElement("span", { "aria-hidden": 'true' }, "* ") : null,
                    label)) : null)),
        errorMessage ? (React.createElement("div", { className: 'Checkbox__errorMessage', role: 'alert' }, errorMessage)) : null));
};
Checkbox.defaultProps = {
    isDisabled: false
};
Checkbox.propTypes = {
    /** Class name to apply to the container div */
    className: PropTypes.string,
    errorMessage: PropTypes.node,
    /** True if the checkbox is checked */
    isChecked: PropTypes.bool.isRequired,
    /** True if the checkbox is disabled */
    isDisabled: PropTypes.bool,
    /** True if the checkbox group state is indeterminate */
    isIndeterminate: PropTypes.bool,
    /** Label text to render to the right of the checkbox */
    label: PropTypes.string,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    /** Function called  with the checkbox's value when the checkbox is clicked */
    onChange: PropTypes.func.isRequired,
    onKeyPress: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
export default Checkbox;
//# sourceMappingURL=Checkbox.js.map